export function formatCurrency(value) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export function formatPercent(value) {
  return `${Number(value || 0).toFixed(1)}%`;
}

export function formatDate(value) {
  if (!value) {
    return 'Sin fecha';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  }).format(date);
}

export function formatStock(stock, stockUnit, decimals = 1) {
  const value = Number(stock || 0);

  if (stockUnit === 'UNIT') {
    return `${Math.round(value)} uds`;
  }

  return `${value.toFixed(decimals)} kg`;
}

export function formatRole(role) {
  switch (role) {
    case 'ADMIN':
      return 'Administrador';
    case 'VENDOR':
      return 'Vendedor';
    case 'CUSTOMER':
      return 'Cliente';
    default:
      return role || 'Invitado';
  }
}